import Vue from 'vue'
import Vuex from 'vuex'
import storage from 'store'
import * as request from '@/request/common'

Vue.use(Vuex)


// 重置数组 (面向舞台)
const getNewArr1 = function(arr) {
  let newArr = [];
  let aArr = [];
  let bArr = [];
  arr.forEach((it, idx) => {
    if (idx % 2 == 0) {
      aArr.push(it);
    } else {
      bArr.push(it);
    }
  });
  aArr.reverse();
  let firstSeat = bArr.splice(bArr.length - 1, 1);
  aArr = firstSeat.concat(aArr);
  newArr = aArr.concat(bArr);
  return newArr
};

// 重置数组 (背向舞台）
const getNewArr2 = function(arr) {
  let newArr = [];
  let aArr = [];
  let bArr = [];
  arr.forEach((it, idx) => {
    if (idx % 2 == 0) {
      aArr.push(it);
    } else {
      bArr.push(it);
    }
  });
  let firstSeat = aArr.splice(0, 1);
  bArr = firstSeat.concat(bArr);
  aArr.reverse();
  newArr = bArr.concat(aArr);
  return newArr
};

export default new Vuex.Store({
  state: {
    scaleNumber:100,          // 缩放等级
    userInfo: {},             // 用户信息
    isShowInvalidSeat: false, // 是否显示无效的座位
    meetingInfo: null,        // 会议基本信息
    contextMenuRef: null,     // 右键的ref实例
    layoutData: [],           // 布局数据
    leftLayoutData: [],       // 左侧拖拽排序的列表
    notSeatPersonList: [],    // 未分配座位的用户列表
    high_person_id: '',        // 高亮人的id
  },
  gettters: {
    scaleNumber: state => state.scaleNumber,
    userInfo: state => state.userInfo,
    isShowInvalidSeat: state => state.isShowInvalidSeat,
    meetingInfo: state => state.meetingInfo,
    layoutData: state => state.layoutData,
    high_person_id: state => state.high_person_id,
    leftLayoutData: state => state.leftLayoutData,
    contextMenuRef: state => state.contextMenuRef,
    notSeatPersonList: state => state.notSeatPersonList,
  },
  mutations: {
    /**
       * 更新属性值的方法
       * @param {Object} state
       * @param {Object} o 要更新的对象 例如{userInfo:{name:'1111'}}
       * 如果更新模块下的state属性时,请使用  模块名.属性名 例如模块index的name {'index.name':'aaa'}
       **/
    updateState(state, o) {
      for (let key in o) {
        let saveKey = ''
        let keyArr = key.split('.')
        let l = keyArr.length
        if (l >= 2) {
          // 使用本地存储时，保存的键名
          saveKey = keyArr[0]
          // 多级更新字段时，需要遍历找到state内对应字段的属性（子元素，例如：a.b.c.d 需要遍历找到 state内a属性的d元素）
          let obj = state[saveKey]
          for (let i = 1; i < l - 1; i++) {
            obj = obj[keyArr[i]]
          }
          // 取最终要更新的字段名
          let k = keyArr[l - 1]
          // 更新state对应字段
          obj[k] = o[key]
        } else {
          // 更新state对应字段
          state[key] = o[key]
        }
      }
    },
  },
  actions: {
    // 获取会议信息
    getMeetingInfo({ state }, data) {
      return new Promise((resolve, reject) => {
        if (!state.meetingInfo) {
          request.post({ url: 'getMeetingInfo', data,costom:{
            errorCallback:(() => {
              // 出错后退出浏览器
              storage.set('auth', '');
              // 关闭浏览器
              var userAgent = navigator.userAgent;
              if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Presto") != -1) {
                  window.location.replace("about:blank");
              } else {
                  window.opener = null;
                  window.open("", "_self");
                  window.close();
              }
            })
           }}).then(res => {
            //   console.log(res);
            state.meetingInfo = res.data;
            storage.set('committee_id', res.data.m_committee_id);
            storage.set('committee_login_url', res.data.domain);
            resolve(state.meetingInfo)
          }).catch((err) => {
            reject(err)
          })
        } else {
          resolve(state.meetingInfo)
        }
      })
    },

    // 获取布局座位信息
    getLayoutData({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        request.post({ url: 'getLayout', data }).then(res => {
          // 数据格式化 圆桌处理
          res.data.forEach(it => {
            if (it.desk_type?.type == 'd_yuan') {
              it.seat_list.forEach(a => {
                a.col.forEach(b => {
                  let seatList = b.seat_item;
                  // 重置数组
                  if (it.direction == 2) {
                    b.seat_item = getNewArr2(seatList);
                  } else {
                    b.seat_item = getNewArr1(seatList);
                  }
                })
              })
            }
          });
          state.layoutData = res.data;
          resolve(res.data)
        })
      })
    },

    // 获取布局座位上列表，左侧拖拽排序用
    getLayoutSeatUser({ state }, costom) {
      return new Promise((resolve, reject) => {
        request.post({ url: 'layoutSeatUser', costom }).then(res => {
          state.leftLayoutData = res.data;
          resolve(res.data)
        })
      })
    },

    // 获取未分配的座位的人员列表
    getNotSeatPersonList({ state }) {
      return new Promise((resolve, reject) => {
        request.post({ url: 'getNotSeatUser' }).then(res => {
          state.notSeatPersonList = res.data;
          resolve(res.data)
        })
      })
    }
  },
  modules: {
  }
})
